import { useScroll } from '@vueuse/core';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { useDisplay } from 'vuetify';

export const useLayoutStore = defineStore('layout', () => {
  const appContentElement = ref<HTMLElement>();
  const pageElement = ref<HTMLElement>();
  const { mobile, mdAndDown, mdAndUp, lgAndDown } = useDisplay();
  const pageTitleVisible = ref(false);
  const pageStatusVisible = ref(false);

  const subNavigationBarHeight = ref(40);
  const statusBarHeight = ref(24);
  const titleHeaderHeight = ref(72);

  const contentScroll = useScroll(appContentElement);

  const headerTop = computed(() => {
    return `${subNavigationBarHeight.value}px`;
  });
  const statusTop = computed(() => {
    let top = subNavigationBarHeight.value;
    if (pageTitleVisible.value) {
      top += titleHeaderHeight.value;
    }
    return `${top}px`;
  });
  const contentTop = computed(() => {
    let top = subNavigationBarHeight.value;
    if (pageTitleVisible.value) {
      top += titleHeaderHeight.value;
    }
    if (pageStatusVisible.value) {
      top += statusBarHeight.value;
    }
    return `${top}px`;
  });

  function setPageTitleVisibility(to: boolean) {
    pageTitleVisible.value = to;
  }
  function setPageStatusVisibility(to: boolean) {
    pageStatusVisible.value = to;
  }
  function setAppContentElement(element: HTMLElement | undefined) {
    appContentElement.value = element;
  }
  function setPageElement(element: HTMLElement | undefined) {
    pageElement.value = element;
  }

  return {
    mobile,
    mdAndDown,
    mdAndUp,
    lgAndDown,
    pageTitleVisible,
    pageStatusVisible,
    setPageTitleVisibility,
    setPageStatusVisibility,
    setAppContentElement,
    setPageElement,
    pageElement,
    headerTop,
    statusTop,
    contentTop,
    ...contentScroll,
    subNavigationBarHeight,
    statusBarHeight,
    titleHeaderHeight,
  };
});
